export class Contacto {
    id: Number
    Imagen: String
    Nombre: String
    Apellido: String
    Email: String
    Telefono: String
}
export class ContactoDetalle extends Contacto {
    Puesto: String
    Empresa: String
    FacebookLink: String
    LinkedinLink: String
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/classes/contacto.class.ts